import { createContext } from 'react';
import { DialogContext } from '../types';
/**
 * Skeleton to provide functionalities to the useDialog hook.
 *
 */
export const dialogContext = createContext<DialogContext>({});
